import React, {useEffect} from 'react'
import {motion} from "framer-motion";

import WorkAllLists from '../components/WorkAllLists'
import Footer from '../components/Footer'

function Home() {


    const height = window.innerHeight;
    document.documentElement.style.setProperty( '--home-hero-vh', height/100 + 'px');


    const LoadingTransition = { duration: 1, ease: [0.43, 0.13, 0.23, 0.96] }

    useEffect(() => {
        // const headerAnim = document.querySelector('.header-anim')
        const heroTitle = document.querySelectorAll('.hero-title')
        
        // header animation
        // setTimeout(() => {
        //     headerAnim.classList.add('header-anim-on')
        // }, 1000)

        // hero animation
        setTimeout(() => {
            heroTitle.forEach((item, index) => {
                setTimeout(() => {
                    item.classList.add('hero-title-on')
                }, 200 * index) 
            })
        }, 1500)
    }, [])
    
    // aniamtion by scroll
    const onScrollBottomAnim = () => {
        const animBot = document.querySelectorAll('.anim-bot')

        animBot.forEach(item => {
            /**
             * getBoundingClientRect()
             * 要素の位置情報を返す。
             * 返す値 → 要素サイズ、top・right・bottom・left、xyの位置
             */
            let itemPosition = item.getBoundingClientRect();

            if(itemPosition.top >= 0  &&  itemPosition.top <= window.innerHeight - 80) {
                item.classList.add('item-anim-bot')
            }
        })   
    }

    useEffect(() => {
        window.addEventListener("scroll", onScrollBottomAnim)
        return () => window.removeEventListener("scroll", onScrollBottomAnim);
    }, [])

    return(
        <div>
            <motion.div 
                initial={{x:0}}
                animate={{x:'-100%'}}
                exit={{x:0}}
                transition={LoadingTransition}
                className="page-trans">
            </motion.div>
            
            {/* <Header /> */}

            <section id="HomeHeroSection" className="section parallax-top-section">
                <div className="container-fluid-small">
                    <div className="row">
                        <div className="col-12">
                            <img src="/oitid/student/assets/images/logo_main.svg" alt="OITID STUDENT EDITION" className="hero-title home-hero-logo"/>
                            <h6 className="sub-title hero-title home-sub-title">OSAKA INSTITUTE of TECHNOLOGY Innovation Days<br/>STUDENT EDITION</h6>
                            <h1 className="big-title hero-title">
                            <span>大阪工業大学 空間デザイン学科学生による</span><br/>デザイン演習作品 アーカイブズ</h1>
                        </div>
                    </div>
                </div>
            </section>

            <WorkAllLists />
            <Footer />
        </div>
    )

}

export default Home;


